import { render, staticRenderFns } from "./show-wait-approval.vue?vue&type=template&id=e729e2ce"
import script from "./show-wait-approval.vue?vue&type=script&lang=js"
export * from "./show-wait-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports